module.exports = __webpack_public_path__ + "img/404.469769de.svg";